import intl from 'react-intl-universal';

import { listToMap } from '@/utils';
import { intlListToMap } from '@/utils/transform';

export const BizSource = 'djjd';

export const SYSTEM_NOTICE_CHECK_MAP = {
  true: '已查看',
  false: '未查看',
};

export enum SystemNoticeConfirm {
  Confirmed = 1,
  NoCheck = 0,
}
export const SYSTEM_NOTICE_CONFIRM_LIST = [
  { label: '已确认', value: 1 },
  { label: '未确认', value: 0 },
];
export const SYSTEM_NOTICE_CONFIRM_MAP = {
  true: '已确认',
  false: '未确认',
};

// 系统公告状态
export enum SystemNoticeStatus {
  Editing = 0,
  WaitToPublish = 1,
  Published = 2,
}
export const SYSTEM_NOTICE_STATUS_LIST = [
  { label: '编辑中', value: SystemNoticeStatus.Editing },
  { label: '待发布', value: SystemNoticeStatus.WaitToPublish },
  { label: '已发布', value: SystemNoticeStatus.Published },
];

export const SYSTEM_NOTICE_STATUS_MAP = listToMap(SYSTEM_NOTICE_STATUS_LIST);
// 售卖类型
export enum SaleType {
  CURRENT_SALE = 0, // 日历房产品
  PRE_SALE = 1, // 预售产品
}
export const saleTypeMap = {
  [SaleType.CURRENT_SALE]: intl.get('channel_operate_log_sale_type_0'),
  [SaleType.PRE_SALE]: intl.get('channel_pre_sale_product'),
};

// 编制审批
export const establishmentList = [
  { label: intl.get('channel_approver_info_wait_approve'), value: 0 },
  { label: intl.get('channel_theater_approval'), value: 1 },
  { label: intl.get('channel_personnel_approval'), value: 2 },
  { label: intl.get('channel_went_into_effect'), value: 3 },
];
export const establishmentListMap = listToMap(establishmentList);

// 操作系统
export enum SysSource {
  CRS = 'CRS',
  PMS = 'PMS',
  MOP = 'MOP',
}
// 积分操作类型
export enum HotelPointsOperate {
  Get = 1,
  Deduct = 2,
  Use = 3,
  Return = 4,
  Overdue = 6,
  Adjust = 7,
}
export const HotelPointsOperateList = [
  { label: intl.get('guest_hotel_points_operate_Get'), value: HotelPointsOperate.Get },
  { label: intl.get('guest_hotel_points_operate_Deduct'), value: HotelPointsOperate.Deduct },
  { label: intl.get('guest_hotel_points_operate_Use'), value: HotelPointsOperate.Use },
  { label: intl.get('guest_hotel_points_operate_Return'), value: HotelPointsOperate.Return },
  { label: intl.get('guest_hotel_points_operate_Overdue'), value: HotelPointsOperate.Overdue },
  { label: intl.get('guest_hotel_points_operate_Adjust'), value: HotelPointsOperate.Adjust },
];
export const HotelPointsOperateMap = listToMap(HotelPointsOperateList);

// 联系方式
export enum ContractType {
  CERTIFICATE = '01',
  EMAIL = '02',
  MOBILE = '03',
}
export const ContractTypeMap = {
  [ContractType.CERTIFICATE]: '证件号',
  [ContractType.EMAIL]: '电子邮箱',
  [ContractType.MOBILE]: '手机号',
};

// 改价最大天数
export const CHANGE_PRICE_MAX_RANGE_DAYS = 180;
// 改价最大周数
export const CHANGE_PRICE_MAX_RANGE_WEEKS = 26;

// 规则引擎Code
export enum ComponentCode {
  // 会员身份限制
  IdentityLimit = '1232',
  // 用户参与限制
  JoinLimit = '1701',
  // 充值门槛金额
  RechargeThreshold = '1311',
  // 充值渠道
  RechargeChannel = '1601',
  // 门店范围
  HotelRange = '1551',
}
export enum ResultComponentCode {
  // 充送内容
  RechargeContent = '2903',
}

// 券规则code
export const CouponRuleCodeMap = {
  deductStartCode: '1311', // 使用门槛
  deductAmountCode: '2332', // 减免金额数值
  deductPercentCode: '2333', // 折扣数值
  useChannelTypeCode: '1601', // 核销途径
  useOccTypeCode: '1333', // 入住类型
  useStoreTypeCode: '1551', // 可用门店范围
  useDateTypeCode: '1451', // 可用日期范围
  userJoinCountCode: '1701', // 用户参与次数
};

/**
 * 活动
 */
// 会员身份类型
export enum MemberIdentityType {
  NoLimit = 1,
  CommonMember = 2,
  NotCommonMember = 3,
  Level = 4,
}

// 参与限制
export enum IsJoinLimit {
  noLimit = 0,
  limit = 1,
}
export enum JoinLimitType {
  // 单门店
  signalHotel = 1,
  // 全门店
  allHotel = 2,
}

/**
 * 优惠券
 */
// 优惠券有效期类型
export enum CouponLifeTimeType {
  Relative = '0', // 相对日期
  Absolute = '1', // 绝对日期
}
export const CouponLifeTimeTypeOption = [
  {
    label: intl.get('config_constant_coupon_time_type_0'),
    value: CouponLifeTimeType.Relative,
  },
  {
    label: intl.get('config_constant_coupon_time_type_1'),
    value: CouponLifeTimeType.Absolute,
  },
];
export const CouponLifeTimeTypeMap = listToMap(CouponLifeTimeTypeOption);

// 优惠券日期类型
export enum CouponLifeDateType {
  Day = 5, // 日
  Week = 4, // 星期
  Month = 2, // 月
  Year = 1, // 年
}
export const CouponLifeDateTypeMap = {
  [CouponLifeDateType.Day]: intl.get('config_constant_coupon_date_type_5'),
  [CouponLifeDateType.Week]: intl.get('config_constant_coupon_date_type_4'),
  [CouponLifeDateType.Month]: intl.get('config_constant_coupon_date_type_2'),
  [CouponLifeDateType.Year]: intl.get('config_constant_coupon_date_type_1'),
};

// 优惠券核销渠道
export enum CouponUseChannelType {
  PMS = 'PMS', // pms
  APP = 'APP', // app
  WXMiniProgram = 'WX_MINI', // 微信小程序
  ALIPAYMiniProgram = 'ALIPAY_MINI', // 支付宝小程序
}
export const CouponUseChannelOption = [
  { label: intl.get('config_constant_coupon_channel_type_pms'), value: CouponUseChannelType.PMS },
  { label: intl.get('config_constant_coupon_channel_type_app'), value: CouponUseChannelType.APP },
  {
    label: intl.get('config_constant_coupon_channel_type_wx_mini'),
    value: CouponUseChannelType.WXMiniProgram,
  },
  {
    label: intl.get('config_constant_coupon_channel_type_alipay_mini'),
    value: CouponUseChannelType.ALIPAYMiniProgram,
  },
];
export const CouponUseChannelMap = listToMap(CouponUseChannelOption);

// 优惠券可用门店范围
export enum CouponUseShopRange {
  AllShop = 0, // 全部门店
  IncludeShop = 1, // 指定门店
  SingleShop = 2, // 单店
}
export const CouponUseShopRangeOption = [
  {
    label: intl.get('config_constant_coupon_store_type_0'),
    value: CouponUseShopRange.AllShop,
  },
  {
    label: intl.get('config_constant_coupon_store_type_1'),
    value: CouponUseShopRange.IncludeShop,
  },
  {
    label: intl.get('config_constant_coupon_store_type_2'),
    value: CouponUseShopRange.SingleShop,
  },
];
export const CouponUseShopRangeMap = listToMap(CouponUseShopRangeOption);

// 优惠券日期类型
export enum CouponTimeTypeEnum {
  Global = 0, // 全时段可用
  Preset = 5, // 预设
  Week = 1, // 每周
  Month = 2, // 每月
  Year = 3, // 每年
  Days = 4, // 单日
}

/**
 * 门店赠券
 */
export enum CycleDateType {
  Total = 1, // 总量
  Day = 2, // 每日
  Week = 3, // 每周
  Month = 4, // 每月
  Year = 5, // 每年
}

export const CycleNameMap = {
  [CycleDateType.Total]: intl.get('config_constant_coupon_cycle_type_1'),
  [CycleDateType.Day]: intl.get('config_constant_coupon_cycle_type_2'),
  [CycleDateType.Week]: intl.get('config_constant_coupon_cycle_type_3'),
  [CycleDateType.Month]: intl.get('config_constant_coupon_cycle_type_4'),
  [CycleDateType.Year]: intl.get('config_constant_coupon_cycle_type_5'),
};

export enum UsageStatus {
  Unavailable,
  Available,
}
export const UsageStatusMap = {
  [UsageStatus.Unavailable]: intl.get('config_constant_staff_usage_status_0'),
  [UsageStatus.Available]: intl.get('config_constant_staff_usage_status_1'),
};

export const JOB_STATUS_LIST = [
  { label: intl.get('config_constant_staff_job_status_0'), value: 0 },
  { label: intl.get('config_constant_staff_job_status_1'), value: 1 },
];
export const JOB_STATUS_MAP = listToMap(JOB_STATUS_LIST);

export enum Gender {
  Man,
  Woman,
}
export const GENDER_LIST = [
  { label: intl.get('config_constant_staff_gender_type_0'), value: 0 },
  { label: intl.get('config_constant_staff_gender_type_1'), value: 1 },
];
export const GENDER_MAP = listToMap(GENDER_LIST);

export const COMPUTER_STATUS_LIST = [
  { label: intl.get('config_constant_computer_status_1'), value: 1 },
  { label: intl.get('config_constant_computer_status_2'), value: 2 },
  { label: intl.get('config_constant_computer_status_3'), value: 3 },
];
export const COMPUTER_STATUS_MAP = listToMap(COMPUTER_STATUS_LIST);

// 查房状态
export enum CheckStatus {
  WaitToCheckRoom = 1,
  HaveCheckRoom = 2,
}
export const CHECK_STATUS_LIST = [
  { label: intl.get('config_constant_room_check_status_1'), value: 1 },
  { label: intl.get('config_constant_room_check_status_2'), value: 2 },
];
export const CHECK_STATUS_MAP = listToMap(CHECK_STATUS_LIST);

// 查房类型
export enum CheckType {
  CheckinCheckRoom = 1,
  ExchangeCheckRoom = 2,
  CheckoutCheckRoom = 3,
}
export const CHECK_TYPE_LIST = [
  { label: intl.get('config_constant_room_check_type_1'), value: 1 },
  { label: intl.get('config_constant_room_check_type_2'), value: 2 },
  { label: intl.get('config_constant_room_check_type_3'), value: 3 },
];
export const CHECK_TYPE_MAP = listToMap(CHECK_TYPE_LIST);

// 入住人身份
export enum MemberType {
  HouseOwner,
  CheckIn,
  Visitor,
  Booker,
}
export const MEMBER_TYPE_LIST = [
  { label: intl.get('config_constant_guest_type_0'), value: 0 },
  { label: intl.get('config_constant_guest_type_1'), value: 1 },
  { label: intl.get('config_constant_guest_type_2'), value: 2 },
  { label: intl.get('config_constant_guest_type_3'), value: 3 },
];
export const MEMBER_TYPE_MAP = listToMap(MEMBER_TYPE_LIST);

// 主订单状态
export enum MainOrderStatus {
  StorageOrder, // 暂存
  ReservationOrder,
  CheckinOrder,
  CancelReservationOrder,
  CheckoutOrder,
  UniteRoomOrder, // 已联房
}
export const MAIN_ORDER_STATUS_LIST = [
  { label: intl.get('config_constant_order_status_0'), value: 0 },
  { label: intl.get('config_constant_order_status_1'), value: 1 },
  { label: intl.get('config_constant_order_status_2'), value: 2 },
  { label: intl.get('config_constant_order_status_3'), value: 3 },
  { label: intl.get('config_constant_order_status_4'), value: 4 },
  { label: intl.get('config_constant_order_status_5'), value: 5 },
];
export const MAIN_ORDER_STATUS_MAP = listToMap(MAIN_ORDER_STATUS_LIST);

// 房间状态
export enum SubOrderStatus {
  StorageOrder = 0,
  Reservation = 1,
  CancelReservation = 2,
  CheckIn = 3,
  CheckOut = 4,
}
export const SUB_ORDER_STATUS_LIST = [
  { label: intl.get('config_constant_order_sub_status_1'), value: 1 },
  { label: intl.get('config_constant_order_sub_status_3'), value: 3 },
  { label: intl.get('config_constant_order_sub_status_2'), value: 2 },
  { label: intl.get('config_constant_order_sub_status_4'), value: 4 },
];
export const SUB_ORDER_STATUS_MAP = listToMap(SUB_ORDER_STATUS_LIST);

// 客源渠道
export enum SourceChannelType {
  CRS = 'CRS', // 中央预订
  WALK_IN = 'WALK_IN', // 线下
  OTA = 'OTA',
  OTHER = 'OTHER',
}

// 计价类型
export enum PriceType {
  MEMBER = 'MEMBER', // 会员价
  MARKET = 'MARKET', // 门市价
  OTA = 'OTA',
}

// 入住类型
export enum OccType {
  DayUse = 'DAY_USE',
  TimeRENT = 'TIME_RENT',
}
export const OCC_TYPE_LIST = [
  {
    get label() {
      return intl.get('app_enum_occ_type_day');
    },
    value: OccType.DayUse,
  },
  {
    get label() {
      return intl.get('app_enum_occ_type_time');
    },
    value: OccType.TimeRENT,
  },
];
export const OCC_TYPE_MAP = intlListToMap(OCC_TYPE_LIST);

// 账务状态
export enum AmountStatus {
  Normal = 0,
  OverdueBill = 2,
  DepositInUse = 3,
  AdvancePaymentShortage = 4,
  NoBill = -1,
}
export const AMOUNT_STATUS_LIST = [
  {
    get label() {
      return intl.get('app_enum_amount_status_normal');
    },
    value: 0,
  },
  {
    get label() {
      return intl.get('app_enum_amount_status_deposit_in_use');
    },
    value: 3,
  },
  {
    get label() {
      return intl.get('app_enum_amount_status_insufficiently_prepaid');
    },
    value: 4,
  },
  {
    get label() {
      return intl.get('app_enum_amount_status_arrears');
    },
    value: 2,
  },
  {
    get label() {
      return intl.get('order_roomorder_enum_BillStatus_noBillItem');
    },
    value: AmountStatus.NoBill,
  },
];

export const AMOUNT_STATUS_MAP = listToMap(AMOUNT_STATUS_LIST);

// 订单账务状态
export const ORDER_BILL_STATUS_LIST = [
  { label: intl.get('config_constant_bill_status_0'), value: 0 },
  { label: intl.get('config_constant_bill_status_1'), value: 1 },
  { label: intl.get('config_constant_bill_status_2'), value: 2 },
  { label: intl.get('config_constant_bill_status_3'), value: 3 },
  { label: intl.get('config_constant_bill_status_4'), value: 4 },
  { label: intl.get('config_constant_bill_status_5'), value: 5 },
];
export const ORDER_BILL_STATE_MAP = listToMap(ORDER_BILL_STATUS_LIST);

export enum ActionType {
  Recharge = '1001',
  Consume = '2002',
  Return = '3002',
  Refund = '3001',
  Withdrawal = '2009',
}
export const ACTION_TYPE_LIST = [
  { label: intl.get('config_constant_action_type_1001'), value: ActionType.Recharge },
  { label: intl.get('config_constant_action_type_2002'), value: ActionType.Consume },
  { label: intl.get('config_constant_action_type_3002'), value: ActionType.Return },
  { label: intl.get('config_constant_action_type_3001'), value: ActionType.Refund },
  { label: intl.get('config_constant_action_type_2009'), value: ActionType.Withdrawal },
];
export const ACTION_TYPE_MAP = listToMap(ACTION_TYPE_LIST);

// 预抵日期
export const ARRIVALTIME_TYPE_LIST = [
  { label: intl.get('config_constant_eta_type_0'), value: 0 },
  { label: intl.get('config_constant_eta_type_3'), value: 3 },
  // { label: intl.get('本周'), value: 1 },
  // { label: intl.get('下周'), value: 2 },
];

// 入住状态
export const LEAVE_STATUS_LIST = [
  { label: intl.get('config_constant_guest_leave_status_0'), value: 0 },
  { label: intl.get('config_constant_guest_leave_status_1'), value: 1 },
];
export const LEAVE_STATUS_MAP = {
  true: intl.get('config_constant_guest_leave_status_1'),
  false: intl.get('config_constant_guest_leave_status_0'),
};

// 房间状态
export const ROOM_STATUS_LIST = [
  { label: intl.get('config_constant_order_sub_status_3'), value: 3 },
  { label: intl.get('config_constant_order_sub_status_4'), value: 4 },
];
export const ROOM_STATUS_MAP = listToMap(ROOM_STATUS_LIST);

// 会员状态
export enum MEMBER_STATUS_FLAG {
  Illegal, // 非会员
  Normal, // 会员
}
export const MEMBER_STATUS_LIST = [
  { label: intl.get('config_constant_guest_member_status_1'), value: MEMBER_STATUS_FLAG.Normal },
  { label: intl.get('config_constant_guest_member_status_0'), value: MEMBER_STATUS_FLAG.Illegal },
];
export const MEMBER_STATUS_MAP = listToMap(MEMBER_STATUS_LIST);

// 证件类型
export enum CertIDType {
  ID_CARD = 11,
  STUDENT_CARD = 15,
  HK_MAC_TW_PASS = 81,
  HK_MAC_TW_COS = 82,
  FOREIGN_ID_CARG = 83,
  OFFICER_CARD = 90,
  POLICE_CARD = 91,
  SOLDIER_CARD = 92,
  HOUSEHOLD_REGISTER = 93,
  PASSPORT = 94,
  TAIWAN_PERMIT = 95,
  HK_PERMIT = 96,
  OTHER = 99,
}

// 证件类型
export const CERT_TYPE_LIST = [
  { label: intl.get('config_constant_cert_type_11'), value: CertIDType.ID_CARD },
  { label: intl.get('config_constant_cert_type_15'), value: CertIDType.STUDENT_CARD },
  { label: intl.get('config_constant_cert_type_81'), value: CertIDType.HK_MAC_TW_PASS },
  { label: intl.get('config_constant_cert_type_82'), value: CertIDType.HK_MAC_TW_COS },
  { label: intl.get('config_constant_cert_type_83'), value: CertIDType.FOREIGN_ID_CARG },
  { label: intl.get('config_constant_cert_type_90'), value: CertIDType.OFFICER_CARD },
  { label: intl.get('config_constant_cert_type_91'), value: CertIDType.POLICE_CARD },
  { label: intl.get('config_constant_cert_type_92'), value: CertIDType.SOLDIER_CARD },
  { label: intl.get('config_constant_cert_type_93'), value: CertIDType.HOUSEHOLD_REGISTER },
  { label: intl.get('config_constant_cert_type_94'), value: CertIDType.PASSPORT },
  { label: intl.get('config_constant_cert_type_95'), value: CertIDType.TAIWAN_PERMIT },
  { label: intl.get('config_constant_cert_type_96'), value: CertIDType.HK_PERMIT },
  { label: intl.get('config_constant_cert_type_99'), value: CertIDType.OTHER },
];

export const CERT_TYPE_MAP = listToMap(CERT_TYPE_LIST);

// 券状态(中台状态)
export enum CouponStatus {
  NotBound,
  Effective,
  Locked,
  Used,
  Expired, // 过期
  Ineffective,
}
export const COUPON_STATUS_LIST = [
  { label: intl.get('config_constant_coupon_status_0'), value: CouponStatus.NotBound },
  { label: intl.get('config_constant_coupon_status_1'), value: CouponStatus.Effective },
  { label: intl.get('config_constant_coupon_status_2'), value: CouponStatus.Locked },
  { label: intl.get('config_constant_coupon_status_3'), value: CouponStatus.Used },
  { label: intl.get('config_constant_coupon_status_4'), value: CouponStatus.Expired },
  { label: intl.get('config_constant_coupon_status_5'), value: CouponStatus.Ineffective },
];
export const COUPON_STATUS_MAP = listToMap(COUPON_STATUS_LIST);

// 券的tab聚合状态
export enum CouponTabStatus {
  CanUse = 'CURRENT_SHOP_AVAILABLE',
  CannotUse = 'UN_AVAILABLE',
  Used = 'USED',
  Expired = 'EXPIRED',
}

// export const CouponScopeMap = {
//   1: intl.get('单店'),
//   2: intl.get('全国'),
// };

// 账单入账类型map
export const BILL_TYPE_LIST = [
  { label: intl.get('config_constant_bill_type_1'), value: 1 },
  { label: intl.get('config_constant_bill_type_4'), value: 4 },
  { label: intl.get('config_constant_bill_type_0'), value: 0 },
  { label: intl.get('config_constant_bill_type_2'), value: 2 },
  { label: intl.get('config_constant_bill_type_3'), value: 3 },
];
export const BILL_TYPE_MAP = listToMap(BILL_TYPE_LIST);

export const OCC_VALUE_MAP = {
  [OccType.DayUse]: intl.get('app_enum_occ_type_day_unit'),
  [OccType.TimeRENT]: intl.get('app_enum_occ_type_time_unit'),
};

// 日租房 预离时间
export const DayDepartureOptions = [
  { label: '07:00:00', value: '07:00:00' },
  { label: '07:30:00', value: '07:30:00' },
  { label: '08:00:00', value: '08:00:00' },
  { label: '08:30:00', value: '08:30:00' },
  { label: '09:00:00', value: '09:00:00' },
  { label: '09:30:00', value: '09:30:00' },
  { label: '10:00:00', value: '10:00:00' },
  { label: '10:30:00', value: '10:30:00' },
  { label: '11:00:00', value: '11:00:00' },
  { label: '11:30:00', value: '11:30:00' },
  { label: '12:00:00', value: '12:00:00' },
  { label: '12:30:00', value: '12:30:00' },
  { label: '13:00:00', value: '13:00:00' },
  { label: '13:30:00', value: '13:30:00' },
  { label: '14:00:00', value: '14:00:00' },
  { label: '14:30:00', value: '14:30:00' },
  { label: '15:00:00', value: '15:00:00' },
  { label: '15:30:00', value: '15:30:00' },
  { label: '16:00:00', value: '16:00:00' },
  { label: '16:30:00', value: '16:30:00' },
  { label: '17:00:00', value: '17:00:00' },
  { label: '17:30:00', value: '17:30:00' },
  { label: '18:00:00', value: '18:00:00' },
];

// 房间脏净状态
export enum RoomCleanStatus {
  Dirty = 0,
  Clean = 1,
}

// 房间不可订状态 前端自定义字段
export enum CustomUnableBookStatus {
  Stop = -1, // 停
  Full = -2, // 满
}

// 房间是否可预订
export enum EnableBookEnum {
  unableBook = 0,
  ableBook = 1,
}

// 房间房态
export enum RoomMainStatus {
  Vacant = 0, // 空房
  Reserved = 1, // 预订
  Occupied = 2, // 在住
  OutService = 3, // 停用
  PreAssigned = 4, // 预排
  CheckOut = 5, // 退房
}

// 房间房态
export const RoomMainStatusMap = {
  [RoomMainStatus.Vacant]: intl.get('config_constant_room_main_status_0'),
  [RoomMainStatus.Reserved]: intl.get('config_constant_room_main_status_1'),
  [RoomMainStatus.Occupied]: intl.get('config_constant_room_main_status_2'),
  [RoomMainStatus.OutService]: intl.get('config_constant_room_main_status_3'),
};

// 房间停用原因类型
export enum RoomDisabledType {
  Maintain = 0, // 维修
  Oneself = 1, // 自用
  Other = 2, // 其他
  LockRoom = 3, // 锁房
}

// 房间停用选项
export const RoomDisabledOption = [
  {
    label: intl.get('roomstate_enum_room_disabled_type_maintain'),
    value: RoomDisabledType.Maintain,
  },
  // { label: intl.get('自用'), value: RoomDisabledType.Oneself },
  {
    label: intl.get('roomstate_enum_room_disabled_type_lock'),
    value: RoomDisabledType.LockRoom,
  },
  {
    label: intl.get('roomstate_enum_room_disabled_type_other'),
    value: RoomDisabledType.Other,
  },
];

// 房间停用原因
export const RoomDisabledReason = listToMap(RoomDisabledOption);

export enum ClientType {
  App = 'WY_APP',
  MiniApp = 'XCX',
}

// 客户端名称
export const CLIENT_NAME_MAP = {
  [ClientType.App]: intl.get('config_constant_crs_client_app'),
  [ClientType.MiniApp]: intl.get('config_constant_crs_client_wx_mini'),
};

// priceChannel
export enum PriceChannel {
  WALK_IN = 'WALK_IN',
  CRS = 'CRS',
  XC = 'XC',
  MT = 'MT',
  DY = 'DY',
  JD = 'JD',
  FZ = 'FZ',
  QNE = 'QNE',
  MT_ZL = 'MT_ZL',
  XC_ZL = 'XC_ZL',
  DY_ZL = 'DY_ZL',
  FX = 'FX',
  ALSL = 'ALSL',
  MTSL = 'MTSL',
  JL = 'JL',
}
export const PRICE_CHANNEL_LIST = [
  { label: intl.get('config_constant_channel_name_walk_in'), value: PriceChannel.WALK_IN },
  { label: intl.get('config_constant_channel_name_crs'), value: PriceChannel.CRS },
  { label: intl.get('config_constant_channel_name_xc'), value: PriceChannel.XC },
  { label: intl.get('config_constant_channel_name_mt'), value: PriceChannel.MT },
  { label: intl.get('config_constant_channel_name_dy'), value: PriceChannel.DY },
  { label: intl.get('config_constant_channel_name_jd'), value: PriceChannel.JD },
  { label: intl.get('config_constant_channel_name_fz'), value: PriceChannel.FZ },
  { label: intl.get('config_constant_channel_name_qne'), value: PriceChannel.QNE },
  { label: intl.get('config_constant_channel_name_fx'), value: PriceChannel.FX },
  { label: intl.get('config_constant_channel_name_alsl'), value: PriceChannel.ALSL },
  { label: intl.get('config_constant_channel_name_mtsl'), value: PriceChannel.MTSL },
  { label: intl.get('config_constant_channel_name_mt_zl'), value: PriceChannel.MT_ZL },
  { label: intl.get('config_constant_channel_name_xc_zl'), value: PriceChannel.XC_ZL },
  { label: intl.get('config_constant_channel_name_dy_zl'), value: PriceChannel.DY_ZL },
  { label: intl.get('reports_ota_config_channel13'), value: PriceChannel.JL },
];
export const PRICE_CHANNEL_MAP = listToMap(PRICE_CHANNEL_LIST);

// 模块
export const MODULE_MAP = {
  RATE: intl.get('config_constant_ota_sync_room_price'),
  INVENTORY: `${intl.get('channel_module_AVAIL')}${intl.get('channel_module_INVENTORY')}`,
};

// 支付渠道
export enum PaymentType {
  CASH = 'CASH',
  ZFB = 'ZFB',
  WX = 'WX',
  BANK_CARD = 'BANK_CARD',
  MEMBER_CARD = 'MEMBER_CARD',
  UNION_PAY = 'UNION_PAY',
  XUANZHU = 'XUANZHU',
  OTA = 'OTA',
  CRS = 'CRS',
}
export const PAYMENT_TYPE_LIST = [
  { label: intl.get('config_constant_pay_type_name_alipay'), value: PaymentType.ZFB },
  { label: intl.get('config_constant_pay_type_name_wechat_pay'), value: PaymentType.WX },
  { label: intl.get('config_constant_pay_type_name_balance'), value: PaymentType.MEMBER_CARD },
  { label: intl.get('config_constant_pay_type_name_cash'), value: PaymentType.CASH },
  { label: intl.get('config_constant_pay_type_name_union_pay'), value: PaymentType.UNION_PAY },
  { label: intl.get('config_constant_pay_type_name_xzye'), value: PaymentType.XUANZHU },
  { label: intl.get('config_constant_pay_type_name_ota_pay'), value: PaymentType.OTA },
  { label: intl.get('config_constant_pay_type_name_crs'), value: PaymentType.CRS },
  { label: intl.get('config_constant_pay_type_name_bank_card'), value: PaymentType.BANK_CARD },
];

// 支付渠道
export const PAY_TYPE_CODE_MAP = {
  ZFB: intl.get('config_constant_pay_type_name_alipay'),
  WX: intl.get('config_constant_pay_type_name_wechat_pay'),
  MEMBER_CARD: intl.get('config_constant_pay_type_name_balance'),
  CASH: intl.get('config_constant_pay_type_name_cash'),
  UNION_PAY: intl.get('config_constant_pay_type_name_union_pay'),
  XUANZHU: intl.get('config_constant_pay_type_name_xzye'),
  BANK_CARD: intl.get('config_constant_pay_type_name_bank_card'),
  CRS: intl.get('config_constant_pay_type_name_crs'),
  XC: intl.get('config_constant_pay_type_name_xc'),
  MT: intl.get('config_constant_pay_type_name_mt'),
  DY: intl.get('config_constant_pay_type_name_dy'),
  JD: intl.get('reports_ota_config_channel14'),
  FZ: intl.get('config_constant_pay_type_name_fz'),
  QNE: intl.get('config_constant_pay_type_name_qne'),
  FKD: intl.get('config_constant_pay_type_name_fkd'),
  FX: intl.get('config_constant_pay_type_name_fx'),
  ALSL: intl.get('config_constant_pay_type_name_alsl'),
  MTSL: intl.get('config_constant_pay_type_name_mtsl'),
  MT_ZL: intl.get('config_constant_pay_type_name_mt_zl'),
  XC_ZL: intl.get('config_constant_pay_type_name_xc_zl'),
  DY_ZL: intl.get('config_constant_pay_type_name_dy_zl'),
  JL: intl.get('reports_ota_config_channel13'),
};

//
export const ALL_PAYMENT_TYPE_LIST = [
  { label: PAY_TYPE_CODE_MAP.ZFB, value: PaymentType.ZFB },
  { label: PAY_TYPE_CODE_MAP.WX, value: PaymentType.WX },
  { label: PAY_TYPE_CODE_MAP.MEMBER_CARD, value: PaymentType.MEMBER_CARD },
  { label: PAY_TYPE_CODE_MAP.CASH, value: PaymentType.CASH },
  { label: PAY_TYPE_CODE_MAP.UNION_PAY, value: PaymentType.UNION_PAY },
  { label: PAY_TYPE_CODE_MAP.XUANZHU, value: PaymentType.XUANZHU },
  { label: intl.get('config_constant_pay_type_name_ota_pay'), value: PaymentType.OTA },
  { label: PAY_TYPE_CODE_MAP.BANK_CARD, value: PaymentType.BANK_CARD },
  { label: intl.get('config_constant_pay_type_name_walk_in'), value: PriceChannel.WALK_IN },
  { label: PAY_TYPE_CODE_MAP.CRS, value: PriceChannel.CRS },
  { label: PAY_TYPE_CODE_MAP.XC, value: PriceChannel.XC },
  { label: PAY_TYPE_CODE_MAP.MT, value: PriceChannel.MT },
  { label: PAY_TYPE_CODE_MAP.DY, value: PriceChannel.DY },
  { label: PAY_TYPE_CODE_MAP.JD, value: PriceChannel.JD },
  { label: PAY_TYPE_CODE_MAP.FZ, value: PriceChannel.FZ },
  { label: PAY_TYPE_CODE_MAP.QNE, value: PriceChannel.QNE },
  { label: PAY_TYPE_CODE_MAP.FX, value: PriceChannel.FX },
  { label: PAY_TYPE_CODE_MAP.ALSL, value: PriceChannel.ALSL },
  { label: PAY_TYPE_CODE_MAP.MTSL, value: PriceChannel.MTSL },
  { label: PAY_TYPE_CODE_MAP.MT_ZL, value: PriceChannel.MT_ZL },
  { label: PAY_TYPE_CODE_MAP.XC_ZL, value: PriceChannel.XC_ZL },
  { label: PAY_TYPE_CODE_MAP.DY_ZL, value: PriceChannel.DY_ZL },
  { label: PAY_TYPE_CODE_MAP.JL, value: PriceChannel.JL },
];

export const PAYMENT_TYPE_MAP = listToMap(PAYMENT_TYPE_LIST.concat(PRICE_CHANNEL_LIST as any));

// 房态变化场景
export enum RESERVATION_SCENE {
  NewReserve, // 新预订,
  ExtendReserve, // 追加预订,
  ReserveExchange, // 预订换房,
  ReserveModify, // 预订修改
  NewCheckIn, // 新入住,
  ExtendCheckIn, // 追加入住,
  ReserveToNewCheckIn, // 预订转新入住,
  ReserveToExtendCheckIn, // 预订转追加入住,
  CheckInExchange, // 入住换房,
  CheckInModify, // 预订修改
  Renewal, // 续住,
}

// 业务款项编码
export enum PAYMENT_BUSINESS_CODE {
  ROOM_CONSUME = 'ROOM_CONSUME', // 房间业务
  MEMBER_CARD_BUY = 'MEMBER_CARD_BUY', // 会员卡购买
  MEMBER_STORED_VALUE = 'MEMBER_STORED_VALUE', // 会员储值
  FRONT_DESK_DIRECT_SALES = 'FRONT_DESK_DIRECT_SALES', // 前台业务
}

// 账单状态
export enum BillStatus {
  Settled = 1, // 已结
  UnSettled = 0, // 未结
}
// 结账状态
export const BILL_STATUS_LIST = [
  { label: intl.get('config_constant_bill_settle_status_0'), value: BillStatus.UnSettled },
  { label: intl.get('config_constant_bill_settle_status_1'), value: BillStatus.Settled },
  { label: intl.get('order_roomorder_enum_BillStatus_noBillItem'), value: AmountStatus.NoBill },
];
// 账单结账状态map
export const BILL_STATE_MAP = listToMap(BILL_STATUS_LIST);

// 性别
export enum SEX_VALUE_SYMBOL {
  Male = 0,
  Female = 1,
  Unknown = 2,
}

// 身份证 长期有效
export const ID_STANDING_DATE = -99;

// 实时库存房态
export const StockRoomStateType = [
  { label: intl.get('roomstate_room_linen_enum_room_status_occupied'), value: 2 },
  { label: intl.get('app_enum_room_status_reserved'), value: 1 },
  { label: intl.get('app_enum_room_status_vacant'), value: 0 },
  { label: intl.get('app_enum_room_status_invalid'), value: 3 },
];

export const STOCK_ROOM_STATE_MAP = listToMap(StockRoomStateType);

// 商品库存
export const STOCK_STATUS_LIST = [
  { label: intl.get('config_constant_goods_stock_status_1'), value: 1 },
  { label: intl.get('config_constant_goods_stock_status_2'), value: 2 },
  { label: intl.get('config_constant_goods_stock_status_3'), value: 3 },
];

// 流水账操作/库存记录操作 类型
export const TURNOVER_LIST = [
  { label: intl.get('config_constant_goods_turnover_type_1'), value: 1 },
  { label: intl.get('config_constant_goods_turnover_type_2'), value: 2 },
  { label: intl.get('config_constant_goods_turnover_type_3'), value: 3 },
  { label: intl.get('config_constant_goods_turnover_type_4'), value: 4 },
  { label: intl.get('config_constant_goods_turnover_type_5'), value: 5 },
  { label: intl.get('config_constant_goods_turnover_type_6'), value: 6 },
  { label: intl.get('config_constant_goods_turnover_type_7'), value: 7 },
  { label: intl.get('config_constant_goods_turnover_type_8'), value: 8 },
  { label: intl.get('config_constant_goods_turnover_type_9'), value: 9 },
];

// 券场景类型
export const COUPON_TYPE_LIST = [
  { label: intl.get('config_constant_coupon_type_101'), value: '101' },
];
export const COUPON_TYPE_MAP = listToMap(COUPON_TYPE_LIST);

// 券营销类型
export const COUPON_SUB_TYPE_LIST = [
  { label: intl.get('config_constant_coupon_type_10101'), value: '10101' },
  { label: intl.get('config_constant_coupon_type_10102'), value: '10102' },
  { label: intl.get('config_constant_coupon_type_10111'), value: '10111' },
  { label: intl.get('config_constant_coupon_type_10112'), value: '10112' },
  { label: intl.get('config_constant_coupon_type_10116'), value: '10116' },
  // { label: intl.get('电酒住宿直抵券'), value: '10101' },
  // { label: intl.get('电酒住宿满额抵扣券'), value: '10102' },
  // { label: intl.get('电酒住宿折扣券'), value: '10111' },
  // { label: intl.get('电酒住宿满额折扣券'), value: '10112' },
  // { label: intl.get('电酒住宿限额满额折扣券'), value: '10116' },
];
export const COUPON_SUB_TYPE_MAP = listToMap(COUPON_SUB_TYPE_LIST);

// 账务 营业费用
export const FEE_STATUS = [
  { label: intl.get('reports_bill_cash_flow_status_1'), value: 1 },
  { label: intl.get('reports_bill_cash_flow_status_2'), value: 2 },
  { label: intl.get('reports_bill_cash_flow_status_3'), value: 3 },
  { label: intl.get('reports_bill_cash_flow_status_4'), value: 4 },
  { label: intl.get('reports_bill_cash_flow_status_5'), value: 5 },
  { label: intl.get('reports_bill_cash_flow_status_6'), value: 6 },
  { label: intl.get('reports_bill_cash_flow_status_7'), value: 7 },
  { label: intl.get('reports_bill_cash_flow_status_8'), value: 8 },
  { label: intl.get('reports_bill_cash_flow_status_9'), value: 9 },
  { label: intl.get('reports_bill_cash_flow_status_10'), value: 10 },
  { label: intl.get('reports_bill_cash_flow_status_11'), value: 11 },
  { label: intl.get('reports_bill_cash_flow_status_12'), value: 12 },
  { label: intl.get('reports_bill_cash_flow_status_13'), value: 13 },
];

export const BELONG_LIST = [
  { label: intl.get('config_constant_expenses_belong_type_1'), value: 1 },
  { label: intl.get('config_constant_expenses_belong_type_2'), value: 2 },
];

export const CHECK_LIST = [
  { label: intl.get('config_constant_expenses_check_status_1'), value: 1 },
  { label: intl.get('config_constant_expenses_check_status_2'), value: 2 },
  { label: intl.get('config_constant_expenses_check_status_3'), value: 3 },
  { label: intl.get('config_constant_expenses_check_status_4'), value: 4 },
  { label: intl.get('config_constant_expenses_check_status_6'), value: 6 },
  { label: intl.get('config_constant_expenses_check_status_7'), value: 7 },
];

// 屏幕方向
export enum ScreenOrientationType {
  Horizontal = 'H',
  Vertical = 'V',
}

// 屏幕房型名称
export const ScreenOrientationName = {
  [ScreenOrientationType.Horizontal]: intl.get('config_constant_screen_direction_horizontal'),
  [ScreenOrientationType.Vertical]: intl.get('config_constant_screen_direction_vertical'),
};

// 屏幕模板类型
export enum ScreenTemplateType {
  CustomTemplate = 0, // 自定义模版
  PresetTemplate = 1, // 预设模版
}

// 会员卡状态
export enum MemberCardStatus {
  Unbind = 0,
  Effective = 1,
  Overdue = 4,
  ReturnCard = 5,
  logOut = 6,
}
export const MEMBER_CARD_STATUS_LIST = [
  // 未绑定
  { label: intl.get('config_constant_member_card_status_0'), value: MemberCardStatus.Unbind },
  // 已生效
  { label: intl.get('config_constant_member_card_status_1'), value: MemberCardStatus.Effective },
  { label: intl.get('config_constant_member_card_status_4'), value: MemberCardStatus.Overdue },
  // 已失效
  { label: intl.get('config_constant_member_card_status_5'), value: MemberCardStatus.ReturnCard },
  { label: intl.get('config_constant_member_card_status_6'), value: MemberCardStatus.logOut },
];
export const MEMBER_CARD_STATUS_MAP = listToMap(MEMBER_CARD_STATUS_LIST);

// 会员等级
export enum MemberLevel {
  Common,
  Member99,
  Member198,
  Member298,
}

// 券类型
export enum GroupConponType {
  GrouponCoupon = 1,
  CashCoupon = 2,
  CardConpon = 3,
}

// 修改方式
export enum SystemCode {
  PMS = 'PMS',
  EOMS = 'EOMS',
  YGJ = 'YGJ',
  AUTO = 'AUTO',
}
export const SYSTEM_CODE_LIST = [
  { label: intl.get('config_constant_log_system_label_pms'), value: SystemCode.PMS },
  { label: intl.get('config_constant_log_system_label_eoms'), value: SystemCode.EOMS },
  { label: intl.get('config_constant_log_system_label_ygj'), value: SystemCode.YGJ },
  { label: intl.get('config_constant_log_system_label_auto'), value: SystemCode.AUTO },
];
export const SYSTEM_CODE_MAP = listToMap(SYSTEM_CODE_LIST);

export enum SmsSystemSource {
  PMS = 'PMS',
  ALLY = 'ALLY',
  MOP = 'MOP',
}

export const SmsSystemSourceMap = {
  [SmsSystemSource.PMS]: 'PMS',
  [SmsSystemSource.ALLY]: intl.get('app_ALLY'),
  [SmsSystemSource.MOP]: intl.get('app_MOP'),
};

// 证照模版状态
export enum TemplateStatus {
  Cancellation = 2, // 已作废
  HaveExpired = 3,
  Ineffective = 4,
  Effective = 8,
  AboutToExpire = 9, // 即将过期
}
export const TEMPLATE_STATUS_LIST = [
  {
    label: intl.get('config_constant_license_template_status_4'),
    value: TemplateStatus.Ineffective,
  },
  { label: intl.get('config_constant_license_template_status_8'), value: TemplateStatus.Effective },
  {
    label: intl.get('config_constant_license_template_status_9'),
    value: TemplateStatus.AboutToExpire,
  },
  {
    label: intl.get('config_constant_license_template_status_3'),
    value: TemplateStatus.HaveExpired,
  },
  {
    label: intl.get('config_constant_license_template_status_2'),
    value: TemplateStatus.Cancellation,
  },
];
export const TEMPLATE_STATUS_MAP = listToMap(TEMPLATE_STATUS_LIST);

// 表单类型
export enum InputType {
  TEXT = 'TEXT',
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  IMAGE_UPLOAD = 'IMAGE_UPLOAD',
  RADIO = 'RADIO',
}

// 房间布草操作类型
export enum LinenActionType {
  LINEN_ROOM = 'LINEN_ROOM', // 布草间布草换洗
  ROOM = 'ROOM', // 房间布草换洗
  CLEAN_ROOM = 'CLEAN_ROOM', // 客房服务员清洁换洗
  CLEAN_UP = 'CLEAN_UP', // 房间直接置净
}
export const LinenActionTypeList = [
  {
    label: intl.get('roomstate_room_linen_history_type_option_linen_room'),
    value: LinenActionType.LINEN_ROOM,
  },
  { label: intl.get('roomstate_room_linen_history_type_option_room'), value: LinenActionType.ROOM },
  {
    label: intl.get('roomstate_room_linen_history_type_option_clean_room'),
    value: LinenActionType.CLEAN_ROOM,
  },
  {
    label: intl.get('roomstate_room_linen_history_type_option_clean_up'),
    value: LinenActionType.CLEAN_UP,
  },
];
export const LinenActionTypeMap = listToMap(LinenActionTypeList);
export const matchStatus = {
  0: intl.get('config_constant_ygp_game_status_0'),
  1: intl.get('config_constant_ygp_game_status_1'),
  2: intl.get('config_constant_ygp_game_status_2'),
  3: intl.get('config_constant_ygp_game_status_3'),
  4: intl.get('config_constant_ygp_game_status_4'),
  5: intl.get('config_constant_ygp_game_status_5'),
  6: intl.get('config_constant_ygp_game_status_6'),
  7: intl.get('config_constant_ygp_game_status_7'),
};

export const channelOrderStatus = [
  {
    value: '1',
    label: intl.get('config_constant_channel_order_status_1'),
  },
  {
    value: '50',
    label: intl.get('config_constant_channel_order_status_50'),
  },
  {
    value: '51',
    label: intl.get('config_constant_channel_order_status_51'),
  },
  {
    value: '14',
    label: intl.get('config_constant_channel_order_status_14'),
  },
  {
    value: '2',
    label: intl.get('config_constant_channel_order_status_2'),
  },
  {
    value: '5',
    label: intl.get('config_constant_channel_order_status_5'),
  },
  {
    value: '11',
    label: intl.get('config_constant_channel_order_status_11'),
  },
  {
    value: '12',
    label: intl.get('config_constant_channel_order_status_12'),
  },
  {
    value: '13',
    label: intl.get('config_constant_channel_order_status_13'),
  },
];

export enum ChangePriceType {
  Base = 1,
  BatchBase = 2,
  Special = 3,
  BatchSpecial = 4,
  SmartSpecial = 5,
  CRS = 6,
  MT = 7,
  XC = 8,
  YGJSpecial = 9,
  YGJBatchSpecial = 10,
  CTRIPPromotion = 12,
  XC_ACTIVITY = 11,
  MT_ZL = 13,
  DY_ZL = 14,
  XC_ZL = 15,
  CRS_NEW = 16,
}

export const sourceMap = {
  OA: intl.get('config_constant_profile_sync_source_oa'),
  EOMS: intl.get('config_constant_profile_sync_source_eoms'),
};

export const storeLetterMap = {
  3: intl.get('config_constant_letter_type_reform'),
  1: intl.get('config_constant_letter_type_break_contract'),
  4: intl.get('config_constant_letter_type_risk_guidance'),
  5: intl.get('config_constant_letter_type_certificate_authorization'),
};

// 优惠券类型
export enum CouponType {
  Deduction = 1,
  Discount = 2,
}

// 商品-仓库类型
export enum StorageTypeEnum {
  Store = 1,
  Font = 2,
  Room = 3,
}
export const StorageTypeMap = {
  1: intl.get('config_constant_storage_type_store'),
  2: intl.get('config_constant_storage_type_reception'),
  3: intl.get('config_constant_storage_type_room'),
};

// 外设-仓库类型
export enum PeripheralStorageTypeEnum {
  Store = 1, // 总库存
  Peripheral = 2, // 外设柜
  Room = 3, // 房间仓
}
export const PeripheralStorageTypeMap = {
  1: '总库存',
  2: '外设柜', // 外设柜
  3: '房间仓', // 房间仓
};

// 商品类型
export const goodsTypeMap = {
  0: intl.get('config_constant_goods_type_actual'),
  1: intl.get('config_constant_goods_type_virtual'),
};

// 商品采购渠道
export const goodsPurchaseChannelMap = {
  0: intl.get('config_constant_goods_channel_group'),
  1: intl.get('config_constant_goods_channel_store'),
};
export const goodsIsHideMap = {
  0: intl.get('config_constant_goods_status_disabled'),
  1: intl.get('config_constant_goods_status_active'),
};
// 外设租借
export const peripheralIsHideMap = {
  1: '可租',
  0: '停止租借',
};
// 订单类型
export enum OrderType {
  roomBillOrder = 'roomBillOrder',
  receptionConsume = 'receptionConsume',
  receptionGoods = 'receptionGoods',
  goodsSelfService = 'goodsSelfService',
  memberCard = 'memberCard',
  rechargeOrder = 'rechargeOrder',
}

export const ORDER_TYPE_LIST = [
  { label: intl.get('config_constant_order_type_room_bill'), value: OrderType.roomBillOrder },
  {
    label: intl.get('config_constant_order_type_reception_consume'),
    value: OrderType.receptionConsume,
  },
  {
    label: intl.get('config_constant_order_type_reception_goods'),
    value: OrderType.receptionGoods,
  },
  { label: intl.get('config_constant_order_type_self_service'), value: OrderType.goodsSelfService },
  { label: intl.get('config_constant_order_type_member_card'), value: OrderType.memberCard },
  { label: intl.get('config_constant_order_type_member_recharge'), value: OrderType.rechargeOrder },
];
export const ORDER_TYPE_MAP = listToMap(ORDER_TYPE_LIST);

// 1：创建审批单、2：提交区域审批、3：撤回审批、4：区域审批通过、5：区域审批退回、6：盟友审批通过、7：盟友审批退回
export enum CashflowOperationType {
  Create = 1,
  Submit = 2,
  WithDraw = 3,
  RegionPass = 4,
  RegionReject = 5,
  AllyPass = 6,
  AllyReject = 7,
}
// 现流审批状态
export enum CashflowApprovalStatus {
  WAIT_REPORT = 1, // 待提交审批
  REGION_APPROVAL = 2, // 区域审批中
  REGION_DISAGREE = 3, // 区域审批退回(状态同待提交审批)
  ALLY_APPROVAL = 4, // 盟友审批中
  ALLY_DISAGREE = 5, // 盟友审批退回(状态同待提交审批)
  ALL_PASS = 6, // 已全部审批
  PART_PASS = 7, // 已部分审批 （状态同待提交审批,可以继续提交区域审批）
  ARCHIVED = 8, // 已归档 归档时不需要更新费用状态
}
export const CASHFLOW_APPROVAL_STATUS_LIST = [
  { label: intl.get('reports_bill_cash_flow_status_2'), value: CashflowApprovalStatus.WAIT_REPORT },
  {
    label: intl.get('reports_bill_cash_flow_status_3'),
    value: CashflowApprovalStatus.REGION_APPROVAL,
  },
  {
    label: intl.get('reports_bill_cash_flow_status_4'),
    value: CashflowApprovalStatus.REGION_DISAGREE,
  },
  {
    label: intl.get('reports_bill_cash_flow_status_5'),
    value: CashflowApprovalStatus.ALLY_APPROVAL,
  },
  {
    label: intl.get('reports_bill_cash_flow_status_6'),
    value: CashflowApprovalStatus.ALLY_DISAGREE,
  },
  {
    label: intl.get('reports_bill_cash_flow_status_Full_approval'),
    value: CashflowApprovalStatus.ALL_PASS,
  },
  {
    label: intl.get('reports_bill_cash_flow_status_part_approval'),
    value: CashflowApprovalStatus.PART_PASS,
  },
  {
    label: intl.get('reports_bill_cash_flow_status_Have_been_filed'),
    value: CashflowApprovalStatus.ARCHIVED,
  },
];
export const CASHFLOW_APPROVAL_STATUS_MAP = listToMap(CASHFLOW_APPROVAL_STATUS_LIST);

// 费用状态
export enum CostStatus {
  WAIT_INTO_CASH_FLOW = 1, // 待归入现流表
  WAIT_REPORT = 2, // 待提交审批
  REGION_APPROVAL = 3, // 区域审批中
  REGION_DISAGREE = 4, // 区域审批退回
  ALLY_APPROVAL = 5, // 盟友审批中
  ALLY_DISAGREE = 6, // 盟友审批退回
  ALL_PASS = 7, // 已完成审批
  SUBMIT_OVERDUE = 8, // 提交审批逾期
  REGION_APPROVAL_OVERDUE = 9, // 区域审批逾期
  REGION_DEAL_UNDONE = 10, // 区域退回未处理
  ALLY_APPROVAL_OVERDUE = 11, // 盟友审批逾期
  ALLY_DEAL_UNDONE = 12, // 盟友退回未处理
  INVALID = 13, // 已作废
}
export const COST_STATUS_LIST = [
  { label: intl.get('reports_bill_cash_flow_status_1'), value: CostStatus.WAIT_INTO_CASH_FLOW },
  { label: intl.get('reports_bill_cash_flow_status_2'), value: CostStatus.WAIT_REPORT },
  { label: intl.get('reports_bill_cash_flow_status_3'), value: CostStatus.REGION_APPROVAL },
  { label: intl.get('reports_bill_cash_flow_status_4'), value: CostStatus.REGION_DISAGREE },
  { label: intl.get('reports_bill_cash_flow_status_5'), value: CostStatus.ALLY_APPROVAL },
  { label: intl.get('reports_bill_cash_flow_status_6'), value: CostStatus.ALLY_DISAGREE },
  { label: intl.get('reports_bill_cash_flow_status_7'), value: CostStatus.ALL_PASS },
  { label: intl.get('reports_bill_cash_flow_status_8'), value: CostStatus.SUBMIT_OVERDUE },
  { label: intl.get('reports_bill_cash_flow_status_9'), value: CostStatus.REGION_APPROVAL_OVERDUE },
  { label: intl.get('reports_bill_cash_flow_status_10'), value: CostStatus.REGION_DEAL_UNDONE },
  { label: intl.get('reports_bill_cash_flow_status_11'), value: CostStatus.ALLY_APPROVAL_OVERDUE },
  { label: intl.get('reports_bill_cash_flow_status_12'), value: CostStatus.ALLY_DEAL_UNDONE },
  { label: intl.get('reports_bill_cash_flow_status_13'), value: CostStatus.INVALID },
];
export const COST_STATUS_MAP = listToMap(COST_STATUS_LIST);

export const OPERATE_LIST = [
  { label: intl.get('app_join'), value: 'REGISTER' },
  { label: intl.get('app_table_content_edit_btn'), value: 'EDIT' },
  { label: intl.get('reports_ota_bill_modal4_radio3'), value: 'CANCEL' },
  { label: intl.get('app_expire'), value: 'EXPIRE' },
  { label: intl.get('app_exit'), value: 'QUIT' },
];
export const OPERATE_MAP = listToMap(OPERATE_LIST);

// export const PROMOTION_TYPE_LIST = [
//   { label: intl.get('channel_DAY_SPECIAL'), value: '0' },
//   { label: intl.get('channel_NEW_CUSTOMER_DISCOUNT'), value: '1' },
//   { label: intl.get('channel_TONIGHT_SALE'), value: '2' },
//   { label: intl.get('channel_CONNECTED_DISCOUNT'), value: '3' },
//   { label: intl.get('channel_ADVANCE_BOOKING'), value: '4' },
//   { label: intl.get('channel_BUY_LIMIT'), value: '5' },
//   { label: intl.get('channel_ctrip_promotion_type_214'), value: '6' },
//   { label: intl.get('channel_ctrip_promotion_type_212'), value: '7' },
//   { label: intl.get('channel_ctrip_promotion_type_178'), value: '8' },
// ];
// export const PROMOTION_TYPE_MAP = listToMap(PROMOTION_TYPE_LIST);

// 统控促销状态 1-统控，2-自营
export const CONTROL_PROMOTION_LIST = [
  { label: intl.get('channel_control_promotion_unify'), value: 1 },
  { label: intl.get('channel_control_promotion_self'), value: 2 },
];
export const CONTROL_PROMOTION_MAP = listToMap(CONTROL_PROMOTION_LIST);

// 集团折扣率提醒开关 （0-关闭、1-开启）
export enum EDiscountRateAlertSwitchFlag {
  Close = 0,
  Open = 1,
}
export const DISCOUNT_RATE_ALERT_SWITCH_FLAG_LIST = [
  { label: intl.get('app_btn_close'), value: EDiscountRateAlertSwitchFlag.Close },
  { label: intl.get('app_open'), value: EDiscountRateAlertSwitchFlag.Open },
];
export const DISCOUNT_RATE_ALERT_SWITCH_FLAG_MAP = listToMap(CONTROL_PROMOTION_LIST);

export enum EChangePriceMode {
  Normal = 1,
  Different = 2,
}
// 改价模式
export const CHANGE_PRICE_MODE_LIST = [
  { label: intl.get('channel_constant_normal_mode'), value: EChangePriceMode.Normal },
  { label: intl.get('channel_constant_price_defferent_mode'), value: EChangePriceMode.Different },
];
export const CHANGE_PRICE_MODE_MAP = listToMap(CHANGE_PRICE_MODE_LIST);
// ota-同步记录-同步类型
export const SYNC_MODULE_MAP = {
  0: intl.get('config_constant_ota_sync_hotel'),
  1: intl.get('config_constant_ota_sync_room_type'),
  2: intl.get('config_constant_ota_sync_product'),
  3: intl.get('config_constant_ota_sync_room_price'),
  4: intl.get('config_constant_ota_sync_room_num'),
  5: intl.get('config_constant_ota_sync_room_state'),
  9: intl.get('app_promotion'),
};
// ota-同步记录-同步结果
export const SYNC_RESULT_LIST = [
  { label: intl.get('config_constant_ota_sync_success'), value: 1 },
  { label: intl.get('config_constant_ota_sync_fail'), value: 2 },
  { label: intl.get('config_constant_ota_sync_ing'), value: 0 },
];
export const SYNC_RESULT_MAP = listToMap(SYNC_RESULT_LIST);

// 排房提示
export enum ERoomArrangeType {
  RoomFix = 1, // 房间维修
  BeforeBook = 2, // 前有预定
  AfterBook = 3, // 后有预定
}
export const ERoomArrangeTypeTipMap = {
  [ERoomArrangeType.RoomFix]: intl.get('config_constant_room_has_stop'),
  [ERoomArrangeType.BeforeBook]: intl.get('config_constant_before_order_conflict'),
  [ERoomArrangeType.AfterBook]: intl.get('config_constant_after_order_conflict'),
  [-9]: intl.get('config_constant_can_not_change_origin_room'),
};
